export default __webpack_public_path__ + "static/media/comeback.e2b65489.jpg";